export default __webpack_public_path__ + "static/media/Messages.b25a7814.svg";